module.exports = __webpack_public_path__ + "1386128539ae8f4b3b7f17ce0b91a822.svg";